var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#FFFFFF","padding":"10px","border-radius":"5px"}},[_c('div',{staticStyle:{"width":"100%","height":"500px"}},[_c('div',{staticStyle:{"margin":"5px","width":"700px","height":"500px"},attrs:{"id":"chartBody"}})])])
}]

export { render, staticRenderFns }